<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Dynamics Messages</h5>
                <div>
                    <Button label="Dashboard" class="p-button-sm p-mr-2" @click="goToDashboard" icon="pi pi-th-large" />
                    <Button label="Previous" class="p-button-sm p-mr-1" @click="goToPrevious"
                        icon="pi pi-chevron-left" />
                    <Button label="Next" icon="pi pi-chevron-right" @click="goToNext" class="p-button-sm"
                        iconPos="right" />
                </div>
            </div>
            <div class="card p-mt-2">
                <DataTable :value="dynamicsmessage" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="totalRecords" :loading="loading" @page="onPage($event)" class="p-datatable-users"
                    dataKey="mbz1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h6>Admin Name : {{ this.localAdminName ? this.localAdminName : '-' }} </h6>
                        </template>
                        <template v-slot:right>
                            <Button label="Add Dynamic Message" icon="pi pi-plus" @click="toDynamicMessage" />
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column headerStyle="width: 2%" class="align-center"></Column>
                    <Column field="id" header="Sr." headerStyle="width: 5%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="Media Type" headerStyle="width: 10%">
                        <template #body="{ data }">
                            <span v-if="data.sm8 == 1">Audio</span>
                            <span v-else-if="data.sm8 == 2">Message</span>
                            <span v-else-if="data.sm8 == 3">Both</span>
                        </template>
                    </Column>
                    <Column header="Module" field="sm3" class="p-text-capitalize " headerStyle="width: 15%">
                    </Column>
                    <Column header="Screen Title" field="sm4" class="p-text-capitalize" headerStyle="width: 15%">
                    </Column>
                    <Column header="Screen Type" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <span v-if="data.sm9 == 0" :class="'p-text-capitaliz'">Screen Info</span>
                            <span v-if="data.sm9 == 1" :class="'p-text-capitaliz'">Subtitile Info</span>

                        </template>
                    </Column>
                    <Column header="Status" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <span v-if="data.sm6 == 1" :class="'user-badge status-active'">Active</span>
                            <span v-if="data.sm6 == 0" :class="'user-badge status-temp-suspend'">Inactive</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 7%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="editDynamicMessageModalOpen(data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <Dialog v-model:visible="isDialogOpen" :header="isEditMode ? 'Edit Message' : 'Add Message'"
        :style="{ width: '900px' }" :modal="true" class="p-fluid">
        <div>
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label>Media Type <span class="p-error">*</span></label>
                        <Dropdown v-model="audiotype" :options="audioTypeList" optionLabel="label"
                            placeholder="Select Media Type" appendTo="body" />
                        <small class="p-error" v-if="v$.audiotype.$error">
                            {{ v$.audiotype.$errors[0].$message }}
                        </small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Module <span class="p-error">*</span></label>
                        <Dropdown v-model="modules" :options="modulesList" optionLabel="label"
                            placeholder="Select Module" appendTo="body" :disabled="isEditMode" />
                        <small class="p-error" v-if="v$.modules.$error">
                            {{ v$.modules.$errors[0].$message }}
                        </small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Screen Title <span class="p-error">*</span></label>
                        <InputText v-model="screentitle" maxlength="200" placeholder="Enter Screen Title"
                            :disabled="isEditMode" />
                        <small class="p-error" v-if="v$.screentitle.$error">
                            {{ v$.screentitle.$errors[0].$message }}
                        </small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Screen Type</label>
                        <div class="p-formgrid p-grid">
                            <div class="p-field-radiobutton p-col-4">
                                <RadioButton v-model="screentype" :value="0" />
                                <label class="p-ml-2">Screen Info</label>
                            </div>
                            <div class="p-field-radiobutton p-col-4">
                                <RadioButton v-model="screentype" :value="1" />
                                <label class="p-ml-2">Subtitle Info</label>
                            </div>
                        </div>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                            :disabled="!isEditMode" appendTo="body" />
                    </div>
                    <div class="p-field p-col-12" v-if="audiotype && (audiotype.value === 2 || audiotype.value === 3)">
                        <label>Message <span class="p-error">*</span></label>
                        <Textarea v-model="dynamicmessage" rows="3" />
                        <small class="p-error" v-if="v$.dynamicmessage.$error">
                            {{ v$.dynamicmessage.$errors[0].$message }}
                        </small>
                    </div>
                    <div class="p-field p-col-12" v-if="audiotype && (audiotype.value === 1 || audiotype.value === 3)">
                        <div class="p-formgrid p-grid" v-for="(row, index) in audioRows" :key="index">
                            <div class="p-field p-col-12 p-md-5">
                                <label v-if="index === 0">Language <span class="p-error">*</span></label>
                                <Dropdown v-model="row.language" :options="filteredLanguageList(index)"
                                    @change="row.langError = false" optionLabel="label" optionValue="key"
                                    appendTo="body" :filter="true" />
                                <small class="p-error" v-if="row.langError">Language required</small>
                            </div>
                            <div class="p-field p-col-12 p-md-5">
                                <label v-if="index === 0">Upload Audio <span class="p-error">*</span></label>

                                <div v-if="row.audioUrl" class="p-d-flex p-ai-center">
                                    <a :href="row.audioUrl" target="_blank">
                                        <i class="pi pi-volume-up" style="font-size:1.5rem"></i>
                                    </a>
                                    <Button icon="pi pi-times" class="p-button-text p-button-danger"
                                        @click="removeExistingAudio(index)" />
                                </div>

                                <FileUpload v-else mode="basic" accept="audio/mp3" auto
                                    @select="handleAudioUpload($event, index)"
                                    :chooseLabel="row.audioupload ? row.audioupload.name : 'Upload'" />

                                <small class="p-error" v-if="row.audioError">Audio required</small>
                            </div>
                            <div class="p-field p-col-1 p-d-flex p-ai-end">
                                <Button icon="pi pi-plus" class="p-button-rounded p-button-success"
                                    v-if="index === audioRows.length - 1" @click="addAudioRow" />
                            </div>
                            <div class="p-field p-col-1 p-d-flex p-ai-end">
                                <Button icon="pi pi-minus" class="p-button-rounded p-button-danger"
                                    :disabled="audioRows.length === 1" @click="removeAudioRow(index)" />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner'}`"
                class="p-button-text" @click="saveDynamicMessage" />
        </template>
    </Dialog>

</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useRoute } from 'vue-router';
import { useConfirm } from "primevue/useconfirm";
import router from '@/router';
import { required, helpers, requiredIf, numeric } from '@vuelidate/validators';


export default {
    data() {
        return {
            confirm: useConfirm(),
            dynamicsmessage: [],
            v$: useValidate(),
            loading: false,
            page_no: 0,
            totalRecords: 0,
            isEditMode: false,
            showLoaderAddBtn: false,
            rowId: null,
            screentitle: '',
            modulesList: [],
            modules: '',
            dynamicmessage: '',
            language: '',
            audioupload: '',
            isDialogOpen: false,
            audioRows: [
                {
                    language: null,
                    audioupload: null,
                    audioUrl: null,
                    langError: false,
                    audioError: false
                }
            ],
            languageList: [],
            audiotype: '',
            adminstatus: { label: 'Active', value: 1 },
            adminstatusList: [
                { label: 'Active', value: 1 },
                { label: 'Inactive', value: 0 },
            ],
            audioTypeList: [
                { value: 1, label: "Audio" },
                { value: 2, label: "Message" },
                { value: 3, label: "Both" }
            ],
            screentype: 0,
            localAdminName: '',

        };
    },
    validations() {
        return {
            screentitle: {
                required: helpers.withMessage(
                    'Please enter screen title',
                    required
                ),
                numeric: helpers.withMessage(
                    'Screen title must be a number',
                    numeric
                )
            },
            audiotype: {
                required: helpers.withMessage('Please select Audio Type', required)
            },
            modules: {
                required: helpers.withMessage('Please select modules', required)
            },
            dynamicmessage: {
                required: helpers.withMessage(
                    'Please enter message',
                    requiredIf(() =>
                        this.audiotype &&
                        (this.audiotype.value === 2 || this.audiotype.value === 3)
                    )
                )
            },
        };
    },

    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },

    async mounted() {
        const route = useRoute();
        this.loading = true;
        this.routeParam = route.params.adminSubId;
        this.localAdminName = localStorage.localAdminName;
        this.getDynamicScreenMessage({ maa1: this.routeParam });
        this.getClientLanguages({ maa1: this.routeParam });
        this.getAllAdminMenus({ maa1: this.routeParam });
    },
    methods: {
        emptyAudioRow() {
            return {
                language: null,
                audioupload: null,
                audioUrl: null,
                langError: false,
                audioError: false
            };
        },
        removeExistingAudio(index) {
            this.audioRows[index].audioUrl = null;
            this.audioRows[index].audioupload = null;
        },

        getLanguageLabel(key) {
            const lang = this.languageList.find(l => l.key === key);
            return lang ? lang.label : '';
        },
        validateAudioRowsOnly() {
            let valid = true;
            if (this.audiotype && (this.audiotype.value === 1 || this.audiotype.value === 3)) {
                this.audioRows.forEach(row => {
                    row.langError = false;
                    row.audioError = false;
                    const hasLanguage = !!row.language;
                    const hasAudio = !!row.audioupload || !!row.audioUrl;
                    if (!hasLanguage && !hasAudio) {
                        row.langError = true;
                        row.audioError = true;
                        valid = false;
                        return;
                    }
                    if (!hasLanguage) {
                        row.langError = true;
                        valid = false;
                    }
                    if (!hasAudio) {
                        row.audioError = true;
                        valid = false;
                    }
                });
            }

            return valid;
        },
        filteredLanguageList(index) {
            const selectedKeys = this.audioRows
                .filter((row, i) => row.language && i !== index)
                .map(row => row.language);
            return this.languageList.filter(
                lang => !selectedKeys.includes(lang.key)
            );
        },
        addAudioRow() {
            this.audioRows.push({
                language: null,
                audioupload: null,
                langError: false,
                audioError: false
            });
        },
        removeAudioRow(index) {
            this.audioRows.splice(index, 1);
        },
        handleAudioUpload(event, index) {
            const file = event.files[0];
            if (!file || !/\.mp3$/i.test(file.name)) {
                this.audioRows[index].audioError = true;
                return;
            }
            this.audioRows[index].audioupload = file;
            this.audioRows[index].audioUrl = null;
            this.audioRows[index].audioError = false;
        },
        getAllAdminMenus() {
            this.ApiService.getAllAdminMenus({ maa1: this.routeParam }).then((items) => {
                if (items.status === 200) {
                    this.modulesList = items.data;
                }
            })
        },
        getClientLanguages() {
            this.ApiService.getClientLanguages({ maa1: this.routeParam }).then((items) => {
                if (items.status === 200) {

                    this.languageList = items.data;
                }
            })
        },
        getDynamicScreenMessage() {
            this.ApiService.getDynamicScreenMessage({ maa1: this.routeParam }).then((items) => {
                if (items.status === 200) {
                    this.dynamicsmessage = items.data;
                    this.totalRecords = items.count;

                } else {
                    this.dynamicsmessage = [];
                }
                this.loading = false;
            });
        },
        toDynamicMessage() {
            this.isDialogOpen = true;
            this.isEditMode = false;
            this.rowId = null;
            this.screentitle = '';
            this.dynamicmessage = '';
            this.modules = '';
            this.audiotype = '';
            this.screentype = 0;
            this.adminstatus = { label: 'Active', value: 1 };
            this.audioRows = [this.emptyAudioRow()];
            this.v$.$reset();
        },
        saveDynamicMessage() {
            this.v$.$validate();
            let formData = new FormData();
            formData.append('maa1', this.routeParam);

            if (this.isEditMode) {
                formData.append('sm1', this.rowId);
            }
            formData.append('sm2', this.modules?.value);
            formData.append('sm3', this.modules?.label);
            formData.append('sm4', this.screentitle);
            formData.append('sm6', this.adminstatus?.value);
            if (this.audiotype.value === 2 || this.audiotype.value === 3) {
                formData.append('sm5', this.dynamicmessage);
            }
            if (this.audiotype.value === 1 || this.audiotype.value === 3) {

                const audioPayload = this.audioRows.map((row, index) => {
                    if (row.audioupload) {
                        return {
                            key: row.language,
                            value: this.getLanguageLabel(row.language),
                            url: `audioFiles[${index}]`
                        };
                    }
                    return {
                        key: row.language,
                        value: this.getLanguageLabel(row.language),
                        url: row.audioUrl
                    };
                });
                formData.append('sm7', JSON.stringify({
                    data: audioPayload,
                    status: this.adminstatus?.value
                }));
                this.audioRows.forEach((row, index) => {
                    if (row.audioupload) {
                        formData.append(`audioFiles[${index}]`, row.audioupload);
                    }
                });
            }
            formData.append('sm8', this.audiotype?.value);
            formData.append('sm9', this.screentype);
            this.v$.$validate();

            if (this.audiotype.value === 1 || this.audiotype.value === 3) {
                if (!this.validateAudioRowsOnly()) return;
            }
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateDynamicScreenMessage(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getDynamicScreenMessage({ page_no: this.page_no });
                        this.isDialogOpen = false;
                        this.isEditMode = false;
                        this.rowId = null;
                        this.screentitle = '';
                        this.screentitle = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        editDynamicMessageModalOpen(data) {
            this.isDialogOpen = true;
            this.isEditMode = true;
            this.rowId = data.sm1;
            this.screentitle = data.sm4;
            this.dynamicmessage = data.sm5;
            this.screentype = data.sm9;
            this.modules = this.modulesList.find(i => i.value == data.sm2);
            this.adminstatus = this.adminstatusList.find(i => i.value == data.sm6);
            this.audiotype = this.audioTypeList.find(i => i.value == data.sm8);
            if (data.sm7) {
                const parsed = JSON.parse(data.sm7);
                this.audioRows = parsed.data.map(item => ({
                    language: item.key,
                    audioupload: null,
                    audioUrl: item.url,
                    langError: false,
                    audioError: false
                }));
            } else {
                this.audioRows = [this.emptyAudioRow()];
            }
        },

        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getDynamicScreenMessage({ page_no: event.page });
        },
        goToDashboard() {
            router.push({
                name: "admindashboard",
                params: { adminId: this.routeParam },
            });
        },
        goToPrevious() {
            router.push({
                name: "web-bot-template-settings-dashboard",
                params: { adminSubId: this.routeParam },
            });
        },
        goToNext() {
            router.push({
                name: "notification",
                params: { adminSubId: this.routeParam },
            });
        },
    }
};
</script>

<style scoped></style>
